{
  "title": "How to Upload Your Eligibility Enrollment Proof",
  "description": "Upload, check, and re-upload your enrollment proof on the \"Student Eligibility Verification\" page.",
  "headings": [
    "What You'll Accomplish",
    "Applies to",
    "Before You Start",
    "Where to Go",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "Once finished, your enrollment proof is sent for manual review by the organizer, and the result appears on the same page.",
  "roleNote": "Student / Participant",
  "prerequisites": [
    "You're signed in, and the competition's organizer has turned on \"Student Eligibility Verification\"",
    "You have a document ready to upload (an enrollment certificate, student ID card, or another organizer-approved document)",
    "The file is PDF, PNG, JPG, or JPEG, and no larger than 10 MB"
  ],
  "pathLabel": "Competition workspace → Participation Info → Student Eligibility Verification",
  "steps": [
    {
      "title": "1. Open \"Student Eligibility Verification\"",
      "description": "If the competition requires student eligibility verification, the \"Participation Info\" summary in your competition workspace shows a team-completion tile (for example, \"1 / 2 required members have completed verification\"). Click it to open the dedicated \"Student Eligibility Verification\" page."
    },
    {
      "title": "2. Choose a proof type and fill in the basics",
      "description": "Choose a proof type (enrollment certificate, student ID card, or another approved document; this option is hidden if the competition only accepts one type), then enter your school name. Department and student number are optional and can be left blank."
    },
    {
      "title": "3. Upload the file",
      "description": "Choose the file and submit. The system checks the file type and size against the limits right away. Once it succeeds, \"My eligibility status\" on the page changes to \"Under review\"."
    }
  ],
  "afterward": [
    "\"My eligibility status\" shows \"Under review\"",
    "You can click \"Download to view\" on the uploaded file to confirm what was submitted",
    "Once the organizer (that competition's admin) finishes the manual review, the status updates to \"Verified\" or \"Rejected\" (with the rejection reason shown) — nothing here is approved automatically"
  ],
  "nextSteps": "If your proof gets rejected, see \"What to Do When Your Eligibility Proof Is Rejected\" for how to re-upload.",
  "warning": "Your eligibility status never affects whether your registration is complete: even if it currently shows \"Not uploaded\", \"Under review\", \"Rejected\", or \"Expired\", your registration is complete as long as every required field on the registration form is filled in and you've clicked \"Confirm and Complete Registration\" — saving your registration data never checks the eligibility verification result.",
  "faq": [
    {
      "q": "Can I re-upload while it's still under review?",
      "a": "Yes. Under \"My eligibility status\", click \"Replace file\" to expand the form — it's automatically prefilled with your current proof type, school, department, and student number, so you don't have to retype everything. You can swap only the file or edit the details too. If you change your mind partway through, click \"Cancel\" to collapse the form without affecting the proof you already submitted and that is still under review."
    },
    {
      "q": "Can my teammates see the content of my proof?",
      "a": "No. The original proof file is only visible to you and to that competition's organizers who have review permission. Teammates only see your status label (for example, Verified or Under review) in the \"Team eligibility completion\" summary — never the file itself or any rejection reason."
    },
    {
      "q": "How long is my uploaded proof kept?",
      "a": "Under the platform's data-retention policy, the original proof file is automatically and permanently deleted 365 days after the competition ends. Only the review outcome (approved/rejected and when) is kept for later audits — the file itself cannot be recovered."
    }
  ]
}
